import { getRequest } from "services/api";

// GET /master-keep dipaginasi oleh BE (default hanya beberapa data per halaman),
// jadi minta semua data sekaligus dan tetap ikuti pagination kalau BE masih membaginya.
export const getAllMasterKeep = async () => {
  const baseQuery = "all=1&limit=1000";
  const firstRes = await getRequest(`/master-keep?${baseQuery}`);
  if (!firstRes?.success || !Array.isArray(firstRes.data)) return firstRes;

  const currentPage = Number(firstRes.pagination?.current_page) || 1;
  const lastPage = Number(firstRes.pagination?.last_page) || 1;
  if (lastPage <= currentPage) return firstRes;

  const restPages = await Promise.all(
    Array.from({ length: lastPage - currentPage }, (_, index) =>
      getRequest(`/master-keep?${baseQuery}&page=${currentPage + index + 1}`)
    )
  );

  const seenIds = new Set();
  const data = [firstRes, ...restPages]
    .flatMap((res) => (Array.isArray(res?.data) ? res.data : []))
    .filter((item) => {
      if (seenIds.has(item.id)) return false;
      seenIds.add(item.id);
      return true;
    });

  return { ...firstRes, data };
};
